import { useMemo } from 'react';

import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';

type Result = {
	variant?: string;
};

/**
 * `{ variant: variation }` for every real assignment - R1's arms, R2's (CHANGE-99359) and control -
 * mirroring the `variant` field GrowthBook's own `$exposure` event already sends. Spread into the five
 * downstream events (record click, comment click, skip, video submitted, comment submitted) so an
 * analyst can slice any of them by arm without joining back to the exposure event (AC5).
 *
 * Empty unless the assignment is real, applying the same `fallback`/`override` rule as
 * `useTrackExperimentExposure` so `variant` never lands on a wider population than `$exposure` itself:
 * targeting is US + mobile web, so every desktop and non-US session resolves to `'control'` with
 * `fallback: true`, and every QA `?exo.` session forces an arm - neither fires an exposure row an
 * analyst could filter them out by, so labelling them would shift the baseline instead of widening it.
 */
export function useSupporterVoicesVideoFirstTrackingProps(): Result {
	const {
		data: { supporterVoicesVideoFirstExperiment },
	} = usePetitionActionsPageData();
	const { variation, fallback, override } = supporterVoicesVideoFirstExperiment;

	return useMemo(() => (fallback || override ? {} : { variant: variation }), [variation, fallback, override]);
}
